





























import Vue from 'vue';
import Component from 'vue-class-component';
import ProjectInformation from '@/components/ProjectInformation.vue';
import MapView from '@/pages/mapView/MapView.vue';
import { User } from '@/store';

@Component({ 
  components: {
    ProjectInformation,
    MapView
  }
})

class SearchMenu extends Vue {
    
    @User.State('project') project;

    SINGLE_TAB = 'tab-single-search';
    MULTIPLE_TAB = 'tab-multiple-search';

    searchItemClicked(tab_name: string){
        const rootRefs = (this.$root.$refs || {}) as any;
        const mapView = rootRefs.MapView as InstanceType<typeof MapView> | undefined;
        const projectInfo = rootRefs.ProjectInformation as InstanceType<typeof ProjectInformation> | undefined;

        if (mapView?.fullMap) {
            mapView.setIsFullMap(false);
        }
        this.$nextTick(() => {
            if (projectInfo && projectInfo.tab !== tab_name){
                mapView?.clearDevice();
                tab_name === this.SINGLE_TAB 
                    ? projectInfo.mapDevicesChanged(tab_name)
                    : projectInfo.mapDevicesChanged(tab_name, []);
            }
        });
    }
}

export default SearchMenu;
